import { useEffect, useState } from "react";
import { empresaApi } from "@/redux/api/empresaApi";
import { useActualizarUsuarioMutation, useEliminarUserMutation, userApi } from "@/redux/api/userApi";
import { IUser } from "@/redux/models";
import { IEmpresa } from "@/redux/models/empresaTypes";


export interface TablaUsuariosHookReturnType {
    getUsuarios: () => void;
    usuarios: IUser[];
    isLoading: boolean;
    empresas: IEmpresa[];
    editarUsuario: (user: Partial<IUser>) => Promise<void>;
    eliminarUsuario: (id: number, code: string) => Promise<void>;
    setUsuarios: (users: IUser[]) => void;
}

const useTablaUsuarios = (): TablaUsuariosHookReturnType => {
    const [GetAllUsers] = userApi.endpoints.getAllUsers.useLazyQuery()
    const [GetAllEmpresas] = empresaApi.endpoints.obtenerEmpresas.useLazyQuery()
    const [actualizarUsuario] = useActualizarUsuarioMutation()
    const [eliminarUsuarioMutation] = useEliminarUserMutation()
    const [empresas, setEmpresas] = useState<IEmpresa[]>([])
    const [usuarios, setUserList] = useState<IUser[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        GetAllEmpresas({ desde: 1, hasta: 1000 })
            .unwrap()
            .then((response) => {
                setEmpresas(response?.data || [])
            })
            .catch((error) => {
                console.error("Error fetching companies:", error);
            })
    }, [])

    const editarUsuario = async (user: Partial<IUser>) => {
        setIsLoading(true)
        actualizarUsuario(user as IUser).unwrap()
            .then(() => {
                setUserList(usuarios.map((u: IUser) => {
                    if (u.id === user.id) {
                        const company = empresas.find((e) => e.id === user.company?.id)
                        return { ...u, ...user, company };
                    }
                    return u;
                }));
            })
            .catch((error) => {
                console.error("Error updating user:", error);
            })
            .finally(() => setIsLoading(false))
    }

    const eliminarUsuario = async (id: number, code: string) => {
        setIsLoading(true)
        return eliminarUsuarioMutation({ id, code }).unwrap()
            .then(() => {
                setUserList(usuarios.filter((u: IUser) => u.id !== id))
            })
            .finally(() => setIsLoading(false))
    }

    const getUsuarios = async () => {
        setIsLoading(true)
        GetAllUsers({}).unwrap()
            .then((response) => {
                setUserList(response?.data || [])
            })
            .catch((error) => {
                console.error("Error fetching users:", error);
            })
            .finally(() => {
                setIsLoading(false)
            })
    }


    return {
        getUsuarios,
        usuarios,
        isLoading,
        empresas,
        editarUsuario,
        eliminarUsuario,
        setUsuarios: setUserList
    }

}

export default useTablaUsuarios